import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v16h16l4 4V2zm-5 9h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
}), 'AddCommentSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AddCommentSharp.js
// module id = 1886
// module chunks = 2